import { gql } from '@urql/core';

// On future changes, check IMPERSONATE_MUTATION below
export const LOGIN_MUTATION = gql`
  mutation ($input: LoginInput!) {
    login(input: $input) {
      access_token
      refresh_token
      expires_in
      user {
        id
        name 
        first_name
        last_name
        infix
        onfido_hash
        onfido_checked
        roles {
          id
          type
          status
          role_data {
            ... on Advisor {
              type
              has_mandate
            }
          }
        }
      }
    }
  }
`;

// On future changes, check LOGIN_MUTATION above
export const IMPERSONATE_MUTATION = gql`
  mutation ($input: TokenLoginInput!) {
    tokenLogin(input: $input) {
      access_token
      refresh_token
      expires_in
      user {
        id
        name
        first_name
        last_name
        infix
        onfido_hash
        onfido_checked
        roles {
          id
          type
          status
          role_data {
            ... on Advisor {
              type
              has_mandate
            }
          }
        }
      }
    }
  }
`;

export const REFRESH_TOKEN_MUTATION = gql`
  mutation ($input: RefreshTokenInput!) {
    refreshToken(input: $input) {
      access_token
      refresh_token
      expires_in
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation {
    logout {
      status
      message
    }
  }
`;

export const REQUEST_PASSWORD_RESET = gql`
  mutation ($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_FORGOTTEN_PASSWORD = gql`
  mutation ($input: UpdateForgottenPasswordInput!) {
    updateForgottenPassword(input: $input) {
      message
      status
    }
  }
`;
